import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as L from 'leaflet';
import moment from 'moment';
import { Api } from 'src/app/services/api';
import { SharedModule } from "src/app/shared/shared-module";
import { MyCheckin } from '../../my-checkin/my-checkin';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';



interface SucursalGeo {
  id: string;
  nombre: string;
  lat: number;
  lng: number;
}

interface SucursalesConfig {
  radius: number;
  byKey: Record<string, SucursalGeo>;
}


@Component({
  selector: 'app-checkin',
  templateUrl: './checkin.component.html',
  styleUrls: ['./checkin.component.scss'],
  imports: [SharedModule,CommonModule]
})
export class CheckinComponent implements OnInit, AfterViewInit {
// Fix para iconos de Leaflet que no cargan
iconRetinaUrl = 'assets/leaflet/marker-icon-2x.png';
iconUrl = 'assets/leaflet/marker-icon.png';
shadowUrl = 'assets/leaflet/marker-shadow.png';
// activeSucursal: any = null;
activeSucursal: SucursalGeo | null = null;
esadmin: boolean = false;
loading:boolean = false;
  map!: L.Map;
  marker!: L.Marker;
hoyasDia = moment().format('dddd');
  coords: any = null;
  errorMessage = '';
//     lat: 18.91845,
checkinsPending=[];
  sucursal = {
    lat: 6.91845,
    lng: -99.23418,
    radius: 200 // metros
  };
  Thesucursales: SucursalesConfig = {
  radius: 200,
  byKey: {}
};
  geofenceStatus: 'dentro' | 'fuera' | 'desconocido' = 'desconocido';
saving: boolean = false;
clickCount = 0;
EsAdmin:boolean = false;
clickTimer: any = null;
  constructor(private apiservice:Api,private dialogRef: MatDialogRef<CheckinComponent>, private dialog: MatDialog) {
    // FIX: Aplicar los íconos UNA sola vez en el constructor
    (L.Icon.Default as any).mergeOptions({
      iconRetinaUrl: this.iconRetinaUrl,
      iconUrl: this.iconUrl,
      shadowUrl: this.shadowUrl
    });
  }
  ngOnInit() {
      this.sucursales();
      this.esadmin =  this.apiservice.roleListAdmin.includes(localStorage.getItem('rol'));
  }
  normalizeText(text: string): string {
  return text
    .normalize('NFD')                 // separa acentos
    .replace(/[\u0300-\u036f]/g, '')  // elimina acentos
    .toLowerCase();                   // opcional
}
  getdia(){
    console.log(this.hoyasDia)
    switch(this.hoyasDia){
      case 'Monday': return 'lunes';
      case 'Tuesday': return 'martes';
      case 'Wednesday': return 'miercoles';
      case 'Thursday': return 'jueves';
      case 'Friday': return 'viernes';
      case 'Saturday': return 'sabado';
      case 'Sunday': return 'domingo';
      default: return this.normalizeText(this.hoyasDia);
    }
  }
  getmyCheckins(){
    const userid = localStorage.getItem('userid');
    const getRole = localStorage.getItem('rol');
    this.EsAdmin = this.apiservice.roleListAdmin.includes(getRole);
    let eldia = this.getDiaHoyForAdmin();
    let qold = `SELECT m.*, att.*
FROM (SELECT m.*,ROW_NUMBER() OVER (ORDER BY STR_TO_DATE(m.shift_start, '%H:%i')) AS rn FROM mycheckin_schedule m
    WHERE m.user_id =${userid} AND m.day_name COLLATE utf8mb4_unicode_ci = '${this.getdia()}'
) m
LEFT JOIN (
    SELECT att.*,ROW_NUMBER() OVER (ORDER BY att.checkintime) AS rn FROM attendace_employee att
    WHERE
        att.employee = ${userid} AND att.checkindate = CURDATE()
) att  ON m.rn = att.rn;`;
 let q=``;
let qother = `SELECT
  m.id,
  m.user_id,
  m.nombre,
  m.apellidop,
  m.TeacherId,
  m.day_name,
  TIME_FORMAT(STR_TO_DATE(m.shift_start, '%H:%i'), '%H:%i:%s') AS shift_start,
  attendace.id AS attendance_id,
  attendace.checkintime,
  attendace.scheduletime
FROM mycheckin_schedule m
LEFT JOIN attendace_employee attendace
  ON attendace.employee = m.user_id
 AND attendace.checkindate = CURDATE()
 AND TIME(attendace.scheduletime) = TIME(STR_TO_DATE(m.shift_start, '%H:%i'))
WHERE m.user_id = '${userid}'
  AND m.day_name COLLATE utf8mb4_unicode_ci = '${this.getdia()}'
ORDER BY STR_TO_DATE(m.shift_start, '%H:%i');`;

let qadmin = `SELECT sy.id, sy.id AS user_id,  sy.nombre, sy.apellidop, sy.id AS TeacherId,
-- fp.sl as lunes, fp.sm as martes,fp.sx as miercoles,fp.sj as jueves,fp.sv as viernes,fp.ss as sabado
${eldia} as shift_start, '${this.getDiaHoy()}' as day_name, attendace.checkindate, attendace.checkintime
FROM sysusers sy
LEFT JOIN financial_profile fp ON fp.employee = sy.id
LEFT JOIN attendace_employee attendace
  ON attendace.employee = sy.id
 AND attendace.checkindate = CURDATE()
 WHERE sy.id = '${userid}'`;
 if(this.EsAdmin){
  q = qadmin;
 }else{
  q = qother;
 }

console.log('Query mis check-ins ', q);
this.apiservice.rawquery('mycheckin_schedule', btoa(q)).subscribe({
    next:(checkins)=>{
        this.checkinsPending = checkins;
        console.log('Mis check-ins recientes:', checkins);
      },
      error:(err)=>{
        console.warn('Error cargando mis check-ins ', err.error.error);
      }
    });
  }
  ngAfterViewInit() {
    console.log('hoyasDia', this.getdia());
    this.getmyCheckins();
    this.loadMap();
  }
// Load sucursales y coorednadas autorizadas
sucursales(){
  this.apiservice.getForTable('sucursales', ` id <> 1`).subscribe({
    next:(coo)=>{
      if(coo.length == 0){
        return;
      }
      console.log(coo);
      coo.forEach(s => {
  if (!s.latitud || !s.longitud) return; // ignora sin coords

  this.Thesucursales.byKey[s.id] = {
    id: s.id,
    nombre: s.nombre,
    lat: Number(s.latitud),
    lng: Number(s.longitud)
  };
});
      if (this.map) {
        this.drawAllSucursales();
      }

    },
    error:(err)=>{
      console.warn('Error leyendo coordinadas ', err.error.error);
    }
  })
}
  loadMap() {
    this.map = L.map('map').setView([19.4326, -99.1332], 13);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19
    }).addTo(this.map);

  }

  getLocationORG() {
    this.errorMessage = '';

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!isSafari && navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' as PermissionName })
        .then((res) => this.requestPosition())
        .catch(() => this.requestPosition());
    } else {
      this.requestPosition();
    }
  }

  requestPositionORG() {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;
        const acc = pos.coords.accuracy;

        this.coords = { lat, lng, accuracy: acc };

        this.updateMap(lat, lng);

        this.evaluateGeofence(lat, lng);

        this.reverseGeocode(lat, lng);
      },
      (err) => {
        this.errorMessage = "No se pudo obtener ubicación. Activa GPS y permisos.";
      },
      {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 0
      }
    );
  }

updateMap(lat: number, lng: number) {
  this.map.setView([lat, lng], 18);

  if (this.marker) this.marker.remove();

  this.marker = L.marker([lat, lng]).addTo(this.map);

  // L.circle([this.sucursal.lat, this.sucursal.lng], {
  //   radius: this.sucursal.radius,
  //   color: "green"
  // }).addTo(this.map);
    // 🟢 Si está dentro de una sucursal, resáltala
  if (this.activeSucursal) {
    L.circle([this.activeSucursal.lat, this.activeSucursal.lng], {
      radius: this.Thesucursales.radius,
      color: 'blue',
      fillColor: '#3b82f6',
      fillOpacity: 0.25
    }).addTo(this.map);
  }
}


drawAllSucursales() {
  for (const key in this.Thesucursales.byKey) {
    const suc = this.Thesucursales.byKey[key];

    // Círculo (geofence)
    L.circle([suc.lat, suc.lng], {
      radius: this.Thesucursales.radius,
      color: 'green',
      fillColor: '#22c55e',
      fillOpacity: 0.2
    }).addTo(this.map);

    // Pin / marcador
    L.marker([suc.lat, suc.lng])
      .addTo(this.map)
      .bindPopup(`<b>${suc.nombre}</b>`);
  }
}

reverseGeocode(lat: number, lng: number) {
  // this.http.get(`/api/reverse-geocode?lat=${lat}&lng=${lng}`)
  //   .subscribe(res => console.log(res));
  console.log(`https://myscapa.com/scapapi/public/reverse.php?lat=${lat}&lng=${lng}`)
        fetch(`https://myscapa.com/scapapi/public/reverse.php?lat=${lat}&lon=${lng}`)
      .then(r => r.json())
      .then(d => console.log("Dirección:", d.display_name));
}
  reverseGeocodeORG(lat: number, lng: number) {
    fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`)
      .then(r => r.json())
      .then(d => console.log("Dirección:", d.display_name));
  }

  doCheckIn(data:any) {
    console.log('datos', data);


  if (!this.coords) {
    this.errorMessage = 'Primero obtén tu ubicación.';
    return;
  }

  this.saving = true;
  this.errorMessage = '';

  const payload = {
    employee: localStorage.getItem('userid'),                                // remplaza por tu usuario logueado
    lat: `${this.coords.lat}`,
    lng: `${this.coords.lng}`,
    accuracy: `${this.coords.accuracy}`,
    geofence: `${this.geofenceStatus}`,
    comment: 'Check-in desde app',
    type: 'entrada',                           // entrada / salida según tu lógica
   sucursal_id: this.activeSucursal?.id ?? null,
    sucursal: `${this.activeSucursal?.nombre}`,
    checkindate: moment().format('YYYY-MM-DD'),
    checkintime: moment().format('HH:mm:ss'),
    scheduletime:!data ? moment().format('HH:mm:ss') : moment(data.shift_start, 'H:mm').format('HH:mm:ss')
                            // si quieres registrar sucursal
  };
console.log(payload);
this.apiservice.addItem(payload,'attendace_employee', false).subscribe({
  next:(done)=>{
this.apiservice.showMessageWithAnimation('check-in recibido', 'success');
      this.close()
  },
  error:(err)=>{
    this.apiservice.showMessageWithAnimation(`Error hacinedo check-in ${err.error.error}`, 'error');

  }
})
  // API usando tu servicio
  // this.api.post('/checkin', payload).subscribe({
  //   next: (resp) => {
  //     console.log("Check-in guardado:", resp);
  //     this.saving = false;
  //   },
  //   error: (err) => {
  //     console.error(err);
  //     this.errorMessage = 'Error al guardar check-in.';
  //     this.saving = false;
  //   }
  // });
}

evaluateGeofenceORG(lat: number, lng: number) {
  const R = 6371e3; // Radio de la tierra en metros
  const lat1 = lat * Math.PI/180;
  const lat2 = this.sucursal.lat * Math.PI/180;
  const dLat = (this.sucursal.lat - lat) * Math.PI/180;
  const dLng = (this.sucursal.lng - lng) * Math.PI/180;

  const a =
    Math.sin(dLat/2)**2 +
    Math.cos(lat1) * Math.cos(lat2) *
    Math.sin(dLng/2)**2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const distance = R * c;

  console.log("Distancia a sucursal:", distance);

  if (distance <= this.sucursal.radius) {
    this.geofenceStatus = 'dentro';
    console.log("Dentro del perímetro");
  } else {
    this.geofenceStatus = 'fuera';
    console.log("Fuera del perímetro");
  }
}

evaluateGeofence(userLat: number, userLng: number) {
  const R = 6371e3; // radio de la tierra en metros

  let insideAny = false;
  let matchedSucursal: any = null;

  for (const key in this.Thesucursales.byKey) {
    const suc = this.Thesucursales.byKey[key];

    const lat1 = userLat * Math.PI / 180;
    const lat2 = suc.lat * Math.PI / 180;
    const dLat = (suc.lat - userLat) * Math.PI / 180;
    const dLng = (suc.lng - userLng) * Math.PI / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1) * Math.cos(lat2) *
      Math.sin(dLng / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    console.log(`Distancia a ${suc.nombre}:`, distance);

    if (distance <= this.Thesucursales.radius) {
      insideAny = true;
      matchedSucursal = suc;
      break; // 👈 ya no necesitas seguir
    }
  }

  if (insideAny) {
    this.geofenceStatus = 'dentro';
    this.activeSucursal = matchedSucursal;
    console.log('Dentro del perímetro de:', matchedSucursal.nombre);
  } else {
    this.geofenceStatus = 'fuera';
    this.activeSucursal = null;
    console.log('Fuera de todas las sucursales');
  }
}

getLocation() {
  this.loading = true;
  setTimeout(() => {

 this.errorMessage = '';

  // Safari, Brave y versiones de Chrome no soportan permissions
  const permissionsSupported = 'permissions' in navigator && !!navigator.permissions;

  if (permissionsSupported) {
    navigator.permissions
      .query({ name: 'geolocation' as PermissionName })
      .then(() => this.requestPosition())
      .catch(() => this.requestPosition());
  } else {
    // Safari / Brave fallback
    this.requestPosition();
  }
  }, 1200);

}
requestPosition() {
  if (!navigator.geolocation) {
    this.errorMessage = "Tu navegador no soporta geolocalización.";
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const { latitude, longitude, accuracy } = pos.coords;

      this.coords = { lat: latitude, lng: longitude, accuracy };
// 1️⃣ Evaluar geofence primero
      this.evaluateGeofence(latitude, longitude);
     //  2️⃣ Actualizar mapa (puede usar activeSucursal)
      this.updateMap(latitude, longitude);
      // this.evaluateGeofence(latitude, longitude);
       // 3️⃣ Reverse geocode (opcional)
      this.reverseGeocode(latitude, longitude);
        this.loading = false;
    },
    (err) => {
      console.error("Error de geolocalización:", err);
        this.loading = false;
      this.errorMessage = "No se pudo obtener tu ubicación. Revisa permisos de Safari/Brave.";
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    }
  );
}
addMine(lat: number, lng: number) {
  const id = `manual_${Date.now()}`; // unique key

  this.Thesucursales.byKey[id] = {
    id,
    nombre: 'Mine',
    lat,
    lng
  };

  // Optional UI updates
  this.drawAllSucursales();
}
onSecretClick() {
  this.clickCount++;

  // reset if too slow
  clearTimeout(this.clickTimer);
  this.clickTimer = setTimeout(() => {
    this.clickCount = 0;
  }, 2000); // 2 seconds window

  if (this.clickCount === 5) {
    this.clickCount = 0;
    console.log('🔥 5 clicks detected!');
    Swal.fire('¡Modo secreto activado!', 'Has desbloqueado una función secreta.', 'success');
    this.addMine(this.coords.lat, this.coords.lng);
  }
}
close() {
  this.dialogRef.close();
}
openCheckin() {
  this.close();
  this.dialog.open(MyCheckin, {
    width: '900px',
    maxWidth: '95vw',
    height: '500px'
  });
}
getDiaHoy(): string {
  const day = moment().day(); // 0 = domingo, 1 = lunes ...

  switch (day) {
    case 0: return 'domingo';
    case 1: return 'lunes';
    case 2: return 'martes';
    case 3: return 'miercoles';
    case 4: return 'jueves';
    case 5: return 'viernes';
    case 6: return 'sabado';
    default: return '';
  }
}
getDiaHoyForAdmin(): string {
  const day = moment().day(); // 0 = domingo, 1 = lunes ...

  switch (day) {
    case 0: return 'fp.sd';
    case 1: return 'fp.sl';
    case 2: return 'fp.sm';
    case 3: return 'fp.sx';
    case 4: return 'fp.sj';
    case 5: return 'fp.sv';
    case 6: return 'fp.ss';
    default: return '';
  }
}
}
